import api from './api';

export async function adminLogin(username, password) {
  const res = await api.post('/api/auth/login', { username, password });
  localStorage.setItem('admin_token', res.data.access_token);
  return res.data;
}

export function adminLogout() {
  localStorage.removeItem('admin_token');
  localStorage.removeItem('portal_token');
  localStorage.removeItem('smm_token');
}

export function isAdminLoggedIn() {
  return !!localStorage.getItem('admin_token');
}

export async function verifyAdminToken() {
  try {
    await api.get('/api/auth/verify');
    return true;
  } catch (error) {
    // Explicit auth failures mean the stored admin token is no longer usable.
    if ([401, 403].includes(error?.response?.status)) {
      return false;
    }
    return true;
  }
}
